// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sorter_wrapper__1ts_g","carper":"Sorter_carper__1Ui_g","down":"Sorter_down__19geZ","asc":"Sorter_asc__230eK","desc":"Sorter_desc__2qzIf"};